import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import TemplateFactory from "../Templates/TemplateFactory";
import SiteAPIClient from "../../api/clients/site";
import { arrEmpty } from "../Helpers";
import { fetchTitlesOptions } from "../Components/TitleArea";

export default function QuotePage() {
  // router
  const location = useLocation();
  // state
  const [titleArea, setTitleArea] = useState(null);
  // vars
  let allowedToLoad = true;

  // get the banner content
  useEffect(() => {
    const loadOptions = async () => {
      try {
        const API = new SiteAPIClient();
        const [response, titlesOptions] = await Promise.all([
          API.getQuoteOptions(),
          fetchTitlesOptions().catch(() => null),
        ]);
        if (true === response.success) {
          const options = response.options;
          const quoteTitle =
            titlesOptions?.special_pages?.quote_title || "Request A Quote";
          // set title area
          setTitleArea({
            title: quoteTitle,
            image: options.quote_featured_image?.sizes?.large || null,
            breadcrumbs: [
              {
                title: "Quote",
                url: "",
              },
            ],
            description: response?.options?.quote_description || null,
          });
        }
      } catch (err) {
        console.error(err);
      }
    };

    {
      location.pathname !== "/_error" && allowedToLoad && loadOptions();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => (allowedToLoad = false);
  }, []); // run once initially

  // early exit
  if (arrEmpty(titleArea)) return null;

  return <TemplateFactory template={"product-quote"} title={titleArea} />;
}
